<!-- Compiled at 2026-09-18T12:45:23.821Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Orders-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]="`Customer request ${screen.request?.projectNumber || screen.requestId}` + (screen.offerId ? ` / vendor offer ${screen.request?.vendorOffers.find(o => o.id == screen.offerId)?.offerNumber}` : '')"
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="top-right"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="top-right"
								data-defined-in="Orders.CustomerRequestView"
							></div>
						</ng-container>
					</ng-template>

					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="content"
								data-defined-in="Orders.CustomerRequestView"
							>
								<Orders-CustomerRequestViewInclude
									[$formDirective]="$formDirective"
									[$disabled]="$disabled"
									[$ignoreValidations]="$ignoreValidations"
									[request]="screen.request"
									[offerId]="screen.offerId"
								>
								</Orders-CustomerRequestViewInclude>
							</div>
						</ng-container>
					</ng-template>
				</Orders-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
